import { useState, useEffect } from 'react';

/* Subscribe to a CSS media query. Returns true while the query matches.
   The initial render reads matchMedia synchronously so the first paint
   already reflects the right viewport (avoids a desktop-grid flash on
   mobile while React hydrates). */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/* Convenience: matches phones / narrow tablets. The grid component is unusable
   below this width — we render the day-by-day form instead. */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 768px)');
}
